import { QueryKeys } from '@shared/domain/queryKeys'
import { useApiClient } from '@shared/hooks/useApiClient'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import type { Category } from '../domain/Bet.domain'

interface UpdateCategoryInput {
  id: string
  name?: string
  color?: string
}

export const useUpdateCategory = () => {
  const api = useApiClient()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id, ...data }: UpdateCategoryInput) => {
      const response = await api.patch<Category>(`/categories/${id}`, data)
      return response.data
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [QueryKeys.Categories] })
      void queryClient.invalidateQueries({ queryKey: [QueryKeys.Bets] })
    },
  })
}
